var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPirateDay(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1040 1040",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M597.99 957.41h-46.75c-5.2 0-9.53-3.98-9.96-9.16l-7-82.92c-.49-5.83 4.11-10.84 9.96-10.84h60.75c5.85 0 10.46 5.01 9.96 10.84l-7 82.92c-.44 5.18-4.77 9.16-9.96 9.16z",
    fill: "#BA732B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M280.1 884.65h121.14c6.23 0 11.29 5.06 11.29 11.29v21.02c0 17.83-14.48 32.31-32.31 32.31H280.1c-17.83 0-32.31-14.48-32.31-32.31 0-17.83 14.48-32.31 32.31-32.31z",
    fill: "#F79253"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M411.53 884.94l1 32.02c0 17.77-14.54 32.31-32.31 32.31H280.1c-17.77 0-32.31-14.54-32.31-32.31",
    stroke: "#F05360",
    strokeWidth: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M635.86 815.79c25.01 0 45.29-20.28 45.29-45.29V455.29c0-63.17-25.61-120.36-67.01-161.76-41.55-41.55-99-67.18-162.44-67-126.35.37-228.08 104.1-228.08 230.45V770.5c0 25.01 20.28 45.29 45.29 45.29h366.95z",
    fill: "#2C848E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M669.07 376.51c3.57 0 6.01-3.64 4.62-6.93a240.325 240.325 0 00-51.46-76.36c-43.47-43.47-103.52-70.35-169.85-70.35-99.5 0-184.84 60.5-221.3 146.72-1.39 3.28 1.05 6.92 4.62 6.92h433.37z",
    fill: "#EF3A48"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M571.15 781.34V629.57c0-65.53-52.53-119.69-118.06-120.07-65.81-.39-119.47 53.03-119.47 118.76v153.08c0 41.75 33.85 75.6 75.6 75.6h86.33c41.75 0 75.6-33.85 75.6-75.6z",
    fill: "#fff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M681.15 757.14v19.8c0 49.71-30.23 92.36-73.31 110.56a119.204 119.204 0 01-36.69 9.02c-3.29.28-6.63.42-10 .42H343.62c-3.37 0-6.71-.14-10-.42a119.204 119.204 0 01-36.69-9.02c-43.08-18.2-73.31-60.85-73.31-110.56v-19.8h457.53z",
    fill: "#044548"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M223.62 757.14h457.53",
    stroke: "#092937",
    strokeWidth: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M296.93 757.14V887.5c11.43 4.84 23.77 7.95 36.69 9.02 3.29.28 6.63.42 10 .42h9.09v-139.8h-55.78zm127.57 0v139.8h55.78v-139.8H424.5zm127.56 0v139.8h9.09c3.37 0 6.71-.14 10-.42 12.92-1.07 25.26-4.18 36.69-9.02V757.14h-55.78z",
    fill: "#092937"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M372.18 386.68h-.01c-32.838 0-59.46 26.621-59.46 59.46v49.27c0 32.839 26.622 59.46 59.46 59.46h.01c32.839 0 59.46-26.621 59.46-59.46v-49.27c0-32.839-26.621-59.46-59.46-59.46z",
    fill: "#fff"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M382.18 524.869c-16.25 0-29.46-13.22-29.46-29.46v-49.26c0-16.25 13.22-29.46 29.46-29.46 16.24 0 29.46 13.22 29.46 29.46v49.26c0 16.25-13.22 29.46-29.46 29.46z",
    fill: "#044548"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M392.22 474.24l19.44 11.22c2.67 1.54 6-.38 6-3.46v-22.45c0-3.08-3.33-5-6-3.46l-19.44 11.22c-2.67 1.54-2.67 5.39 0 6.93z",
    fill: "#fff"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M482.31 402.69h100.58c11.04 0 20 8.96 20 20v53.8c0 38.79-31.5 70.29-70.29 70.29-38.79 0-70.29-31.5-70.29-70.29v-53.8c0-11.04 8.96-20 20-20z",
    fill: "#092937"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M316.82 283.94l351.43 289.97",
    stroke: "#092937",
    strokeWidth: 32,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M406.55 733.61c-13.24 9.45-31.62-.02-31.62-16.28v-55.35c0-16.26 18.38-25.73 31.62-16.28l20.53 14.65c20.12 14.36 20.12 44.25 0 58.61l-20.53 14.65zM498.22 733.61c13.24 9.45 31.62-.02 31.62-16.28v-55.34c0-16.26-18.38-25.73-31.62-16.28l-20.53 14.65c-20.12 14.36-20.12 44.25 0 58.61l20.53 14.65v-.01z",
    fill: "#F05360"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M400.76 689.66h103.26",
    stroke: "#EF3A48",
    strokeWidth: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M460.55 671.5h-16.32c-5.522 0-10 4.477-10 10v16.32c0 5.523 4.478 10 10 10h16.32c5.523 0 10-4.477 10-10V681.5c0-5.523-4.477-10-10-10z",
    fill: "#F05360"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M460.55 671.5c5.52 0 10 4.48 10 10v16.32c0 5.52-4.48 10-10 10h-16.32c-5.52 0-10-4.48-10-10V681.5c0-5.52 4.48-10 10-10h16.32zm0-16h-16.32c-14.34 0-26 11.66-26 26v16.32c0 14.34 11.66 26 26 26h16.32c14.34 0 26-11.66 26-26V681.5c0-14.34-11.66-26-26-26zM211.48 563.09v262.58c0 12.28 10.49 21.98 22.73 20.95 40.17-3.38 74.76-13.93 95.51-21.58 12.4-4.57 20.65-16.37 20.65-29.58V649.28c0-35.73-23.7-67.13-58.06-76.93l-65.95-18.81c-6.96-3.18-14.87 1.91-14.87 9.56l-.01-.01z",
    fill: "#EF3A48"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M234.21 846.62c40.22-3.39 74.84-13.96 95.58-21.61 12.37-4.57 20.58-16.37 20.58-29.56V650.11c0-35.39-23.25-66.57-57.17-76.67l-66.85-19.9",
    stroke: "#B62A35",
    strokeWidth: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M693.3 563.09v262.58c0 12.28-10.49 21.98-22.73 20.95-40.17-3.38-74.76-13.93-95.51-21.58-12.4-4.57-20.65-16.37-20.65-29.58V649.28c0-35.73 23.7-67.13 58.06-76.93l65.95-18.81c6.96-3.18 14.87 1.91 14.87 9.56l.01-.01z",
    fill: "#EF3A48"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M670.57 846.62c-40.22-3.39-74.84-13.96-95.58-21.61-12.37-4.57-20.58-16.37-20.58-29.56V650.11c0-35.39 23.25-66.57 57.17-76.67l66.85-19.9",
    stroke: "#B62A35",
    strokeWidth: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M324.82 680.21a8 8 0 008-8 8 8 0 10-16 0 8 8 0 008 8zM324.82 727.64a8 8 0 008-8 8 8 0 00-8-8 8 8 0 100 16zM324.82 775.06a8 8 0 008-8 8 8 0 00-8-8 8 8 0 100 16z",
    fill: "#B62A35"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M223 567.84L107.21 718.77c-12.74 16.6-4.97 40.74 15.02 46.95 52.2 16.22 111.23-.63 146.44-46.53 17.34-22.6 26.38-48.96 27.6-75.41 1.92-41.48-31.75-75.95-73.27-75.95v.01z",
    fill: "#2C848E"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M280.89 588.57c-14.58-15.27-35.06-24.04-56.19-24.04h-1.97l-80.56 105 22.23 22.23h15.98v15.98l51.09 51.09 2.67-1.57c15.29-9.02 28.55-20.77 39.41-34.93 17.29-22.53 27.12-49.39 28.43-77.66.97-20.92-6.52-40.84-21.08-56.09l-.01-.01z",
    fill: "#EF3A48"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M301.97 644.66c-1.31 28.27-11.14 55.12-28.43 77.66-10.87 14.16-24.12 25.91-39.41 34.93",
    stroke: "#B62A35",
    strokeWidth: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M765.88 347.86v.79c-.13 41.67-34.26 75.25-75.93 75.25h-3.2c-.37-59.02-105.16-106.8-234.36-106.8-129.2 0-233.99 47.79-234.36 106.8h-3.2c-41.68 0-75.81-33.58-75.94-75.25v-.79c0-126.27 95.97-232.77 227.1-265.83 5.25 43.05 41.93 76.39 86.39 76.39s81.16-33.35 86.4-76.41c131.12 33.08 227.1 139.57 227.1 265.84v.01z",
    fill: "#044548"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M632.84 655.94c-15.27-14.58-24.04-35.06-24.04-56.19v-1.97l105-80.56 22.23 22.23v15.98h15.98l51.09 51.09-1.57 2.67c-9.02 15.29-20.77 28.55-34.93 39.41-22.53 17.29-49.39 27.12-77.66 28.43-20.92.97-40.84-6.52-56.09-21.08l-.01-.01z",
    fill: "#EF3A48"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M801.53 609.18c-9.02 15.29-20.77 28.55-34.93 39.41-22.53 17.29-49.39 27.12-77.66 28.43-20.92.97-40.84-6.52-56.09-21.08",
    stroke: "#B62A35",
    strokeWidth: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M838.96 401.69c30.83-31.48 83.38-18.5 97 23.15 15.82 51.85-37.61 95.71-85.77 71.61-5.4-2.79-10.33-6.43-14.77-10.56h21.21l-33.46 33.46c-5.86 5.86-15.36 5.86-21.21 0-5.85-5.86-5.86-15.36 0-21.21l33.46-33.46c5.86-5.86 15.36-5.86 21.21 0 20.82 21.44 56.07 6.84 57.19-22.65.6-22.34-19.72-39.42-41.65-35.7-7.34 1.26-14.08 4.8-19.52 9.91-9.94 8.23-22.47-5.11-13.7-14.53l.01-.02z",
    fill: "#B9C6CC"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M698.593 530.461l33.05-33.05c25.456-25.456 66.793-25.456 92.249 0 25.456 25.456 25.456 66.793 0 92.249l-33.05 33.05-92.249-92.249z",
    fill: "#B9C6CC"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M809.506 598.106l-86.302-86.302c-6.495-6.494-17.024-6.494-23.518 0-6.495 6.495-6.495 17.024 0 23.518l86.302 86.303c6.494 6.494 17.024 6.494 23.518 0 6.495-6.495 6.495-17.024 0-23.519z",
    fill: "#B9C6CC"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M767.16 496c-4.21 4.29-2.11 11.68 3.69 13.26 8.27 2.25 17.42 7.67 25.47 15.72 8.05 8.05 13.47 17.2 15.72 25.47 1.58 5.8 8.97 7.9 13.26 3.69l.09-.09c9.14-9.14 3.53-29.56-12.53-45.61-16.06-16.06-36.48-21.66-45.61-12.53l-.09.09z",
    fill: "#fff"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M435.66 447.41c-.7-33.49-27.74-66.61-63.28-66.61-35.54 0-43.05 16.66-43.05 16.66l106.33 49.95z",
    fill: "#2C848E"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M433.57 447.409l-105.08-53.13",
    stroke: "#036D79",
    strokeWidth: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M453.3 289.54c29.089 0 52.67-23.581 52.67-52.67 0-29.089-23.581-52.67-52.67-52.67-29.088 0-52.67 23.581-52.67 52.67 0 29.089 23.582 52.67 52.67 52.67z",
    fill: "#fff"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M423.14 260.391v31.47M453.3 260.391v31.47M483.45 260.391v31.47",
    stroke: "#044548",
    strokeWidth: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M430.34 243.62c7.594 0 13.75-6.156 13.75-13.75s-6.156-13.75-13.75-13.75-13.75 6.156-13.75 13.75 6.156 13.75 13.75 13.75zM476.26 243.62c7.594 0 13.75-6.156 13.75-13.75s-6.156-13.75-13.75-13.75-13.75 6.156-13.75 13.75 6.156 13.75 13.75 13.75z",
    fill: "#044548"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M479.27 530.43h-74.43v76.88h74.43v-76.88z",
    fill: "#F05360"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M484.33 609.879h-49.5c-16.57 0-30-13.43-30-30v-49.44",
    stroke: "#F79253",
    strokeWidth: 20,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M486.83 498.56h-68.88c-14.171 0-25.66 11.488-25.66 25.66 0 14.171 11.489 25.66 25.66 25.66h68.88c14.172 0 25.66-11.489 25.66-25.66 0-14.172-11.488-25.66-25.66-25.66z",
    fill: "#FED425"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M365.99 82.02c5.25 43.05 41.93 76.39 86.39 76.39s81.16-33.35 86.4-76.41c131.12 33.08 227.1 139.57 227.1 265.84v.79c-.13 41.67-34.26 75.25-75.93 75.25h-3.2c-.37-59.02-105.16-106.8-234.36-106.8-129.2 0-233.99 47.79-234.36 106.8",
    stroke: "#092937",
    strokeWidth: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPirateDay);
export default ForwardRef;